package com.example.mystybag.pdfUtils.expected

actual class PdfFile

actual fun PdfFile.copyToExternalDisk(documentTitle: String): Boolean = false

actual fun sharePDF(file: PdfFile, fileName: String) {}

actual class PDFHelper {
    actual fun printFile(fileName: String, fileForPrinting: PdfFile?) {}
    actual suspend fun downloadFile(link: String, filename: String): PdfFile? = null
}
